import React from 'react'
import PropTypes from 'prop-types'

import { SWIPER_KINDS } from 'Constants/Swipers'

import { ActiveBullet, Bullet, Container } from './styles'

function Bullets({ modifier = SWIPER_KINDS.PROJECTS }) {
  return (
    <Container className={`pagination__container--${modifier}`}>
      <ActiveBullet active />

      <Bullet />
    </Container>
  )
}

Bullets.propTypes = {
  modifier: PropTypes.oneOf([
    SWIPER_KINDS.PROJECTS,
    SWIPER_KINDS.TESTIMONIALS,
    SWIPER_KINDS.CTOS,
  ]),
}

export default Bullets
